import React from 'react';
import Helmet from 'react-helmet';
import { getSubdomain, UTM_DEFAULT_HOME } from '../../../utils/const';
import { sentryError } from '../../../utils/sentryHelpers';

const {
  Heading,
  FivePieceQuotingWidgetAPI,
  RangeSlider,
} = pm_components;

const TERM_LENGTHS_REDESIGN = [
  10,
  15,
  20,
  25,
  30,
];

const Widgets = () => {
  return <>
    <Helmet>
      <title>PolicyMe | Life Insurance Made Easy</title>
      <meta
        name="description"
        content="PolicyMe is Canada’s #1 place for life insurance advice.  Take our free online life insurance check-up to get a personalized recommendation in less than 5 minutes."
      />
    </Helmet>
    <main>
      <div className="page-body">
        <FivePieceQuotingWidgetAPI
          onError={sentryError}
          subdomain={getSubdomain()}
          PM_ENABLE_BROKER_SALES={process.env.GATSBY_PM_ENABLE_BROKER_SALES}
          PM_ENABLE_PM_PRODUCT={process.env.GATSBY_PM_ENABLE_PM_PRODUCT}
        />
      </div>
    </main>
    <style jsx>
      {`
        .page-body {
          text-align: center;
          max-width: 48rem;
          margin: auto;

          :global(.quoting-widget) {
            margin-top: 0.5rem;
          }

          :global(aside) {
            background-color: transparent;
            box-shadow: 0 0.5rem 1rem 0.25rem #f0f0f0;
          }

          :global(.inputContainer::after) {
            border: 0;
          }

          :global(.inputContainer #five-api-birthdate) {
            border-top: solid 1px #d9d9d9 !important;
            border-bottom: solid 1px #d9d9d9 !important;
            border-right: solid 1px #d9d9d9 !important;
          }
        }
      `}
    </style>
  </>;
};

export default Widgets;
